/**
 * Design tokens — single source of truth for color, type, and motion.
 * Do not inline hexes anywhere else in the app.
 */

if (import.meta.hot) import.meta.hot.invalidate();
export const color = {
  bgDeep: "#05070A",
  /** Ocean — a hint of navy so land can sit above it. */
  bgAtmos: "#081525",
  /** Landmass — cool slate, readable as "land" at 12ft viewing distance. */
  geoLand: "#223C5C",
  /** Coastline — distinct but never shouty. */
  geoStroke: "#4A6B94",
  flowPrimary: "#F4C770",
  flowLarge: "#FFE9B0",
  flowFail: "#E5484D",
  flowCool: "#7FB3D5",
  textPrimary: "#E8EEF5",
  textMuted: "#5C6B7E",
  /** Product accents — one per product family. */
  productSend: "#F4C770", // gold — remittance corridors
  productAdd: "#6BE5A3", // mint — deposits feel incoming, healthy
  productExchange: "#A89CFF", // soft violet — conversions feel technical, neutral
  productCard: "#5DD5E5", // cyan — virtual card spend, crisp against gold
} as const;

export const colorHex = color;

/** THREE.Color-friendly numeric hexes for shader uniforms. */
export const colorNum = {
  bgDeep: 0x05070a,
  bgAtmos: 0x081525,
  geoLand: 0x223c5c,
  geoStroke: 0x4a6b94,
  flowPrimary: 0xf4c770,
  flowLarge: 0xffe9b0,
  flowFail: 0xe5484d,
  flowCool: 0x7fb3d5,
  productSend: 0xf4c770,
  productAdd: 0x6be5a3,
  productExchange: 0xa89cff,
  productCard: 0x5dd5e5,
} as const;

export const motion = {
  arcGlobalMs: 4500,
  arcRegionalMs: 2800,
  spotlightCooldownMs: 90_000,
  quietTpsThreshold: 0.5,
  quietDwellMs: 120_000,
  /** Baseline drift — planetarium feel, not a gift-shop globe. ~10 min per revolution. */
  driftDegPerSec: 0.6,
  /** Minimum rotation rate when lingering on an active corridor (still moving). */
  lingerMinDegPerSec: 0.12,
  /** Max speed the camera will track toward active longitudes. */
  biasDegPerSec: 2.2,
  rotationSlowFactor: 0.5,
} as const;

export const font = {
  display: "'Inter Tight', system-ui, sans-serif",
  mono: "'JetBrains Mono', ui-monospace, monospace",
} as const;
